import { v4 as uuid } from "uuid";

export function withId<T>(obj: T): T & { id: string } {
	return { ...obj, id: uuid() };
}

export function withoutId<T extends { id: string }>(obj: T): Omit<T, "id"> {
	const { id, ...rest } = obj;
	return rest;
}
